import {remCalc} from '_themeUtils'

const themeBreakpoints = {
    breakpoints: {
        base: remCalc(0),
        sm: remCalc(480),
        md: remCalc(768),
        lg: remCalc(1024),
        xl: remCalc(1200),
        '2xl': remCalc(1536),
    },
    breakpoinsArray: [remCalc(0), remCalc(480), remCalc(768), remCalc(1024), remCalc(1200), remCalc(1536)], // For cloudinary
}

export default themeBreakpoints
